// extracted by mini-css-extract-plugin
export var printerCard = "_g8-1";
export var printerCardConfigured = "_g8-2";
export var printerCardError = "_g8-3";
export var printerCardsContainer = "_g8-0";
export var printerIcon = "_g8-8";
export var printerIconConfigured = "_g8-5";
export var printerIconContainer = "_g8-4";
export var printerIconError = "_g8-6";
export var printerIconUnconfigured = "_g8-7";
export var workstationsTableCard = "_g8-9";